/* ===========================================================================
   Grupo Marhel — collection.js
   Client-side filter pills (by vendor or product type) with active state and
   show/hide of product cards. No page reload. Vanilla JS.
   =========================================================================== */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-filters]');
    var grid = document.querySelector('[data-collection-grid]');
    if (!bar || !grid) return;

    var filterBy = bar.getAttribute('data-filter-by') || 'vendor';
    var pills = Array.prototype.slice.call(bar.querySelectorAll('.filter-pill'));
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-product-card]'));
    var countEl = bar.querySelector('[data-filter-count]');
    var noResults = document.querySelector('[data-no-results]');

    function cardValue(card) {
      if (filterBy === 'type') return (card.getAttribute('data-type') || '').toLowerCase();
      return (card.getAttribute('data-vendor') || '').toLowerCase();
    }

    function apply(value) {
      var v = (value || '*').toLowerCase();
      var shown = 0;
      cards.forEach(function (card) {
        var match = v === '*' || cardValue(card) === v;
        card.classList.toggle('is-hidden', !match);
        if (match) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' producto' : ' productos');
      if (noResults) noResults.hidden = shown !== 0;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        apply(pill.getAttribute('data-filter'));
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
